<template>
<div>
	<v-card>
		<v-btn class="float-right mt-7 mr-4" @click="export_alignments" :color="export_enabled?'primary':'#ccc'"><v-icon small class="mr-2">fas fa-file-download</v-icon> Export Matches</v-btn>
		<v-btn class="float-right mt-7 mr-4" @click="reset_all_matches" color="secondary"><v-icon small class="mr-2">fas fa-recycle</v-icon> Reset all matches</v-btn>
		<v-btn class="float-right mt-7 mr-4" @click="show_help" color="light-blue" dark><v-icon>fas fa-info-circle</v-icon></v-btn>
		<h3 style="padding:15px 15px 0 15px">
			<v-tooltip bottom><template v-slot:activator="{on}"><v-btn v-on="on" @click="go_to_projects" class="float-left mr-5" fab color="primary"><v-icon>fas fa-arrow-left</v-icon></v-btn></template>Back to projects list</v-tooltip>
			<span v-html="project.project_name"></span>
			<div style="font-size:.8em">CASE Document: <a :href="'https://casenetwork.imsglobal.org/uri/'+cfdocument.identifier" :target="cfdocument.identifier" v-html="cfdocument.title"></a> <nobr>({{project.line_count_case}} rows)</nobr></div>
		</h3>
		<div class="k-table-top-controls-wrapper" :class="show_case_tree?'k-table-top-controls-wrapper-case-tree-showing':''">
			<v-spacer/>
			<div class="k-table-top-controls">
				<h4 style="margin:7px 15px 0 0">Filters:</h4>
				<div>
					<div class="k-key-filters" style="display:flex; margin-top:-10px; margin-bottom:7px; justify-content:space-between">
						<v-checkbox hide-details v-model="filters.unmatched" class="ml-1" :label="filter_labels.unmatched"></v-checkbox>
						<v-checkbox hide-details v-model="filters.matched" class="ml-7" :label="filter_labels.matched"></v-checkbox>
						<v-checkbox hide-details v-model="filters.parked" class="ml-7" :label="filter_labels.parked"></v-checkbox>
						<v-checkbox hide-details v-model="filters.nomatch" class="ml-7" :label="filter_labels.nomatch"></v-checkbox>
					</div>
					<div v-show="filters.unmatched" style="margin:0px 0 -16px 24px; font-size:14px; font-weight:bold; color:#0277BD">Predicted matches for Unmatched items:</div>
					<div v-show="filters.unmatched" style="display:flex; margin-left:20px; margin-bottom:10px">
						<v-checkbox hide-details v-model="filters.conf_high" class="ml-1" :label="filter_labels.conf_high"></v-checkbox>
						<v-btn v-show="filter_counts.conf_high>0" style="margin:22px 0 0 4px" x-small color="primary" @click="batch_match">Batch Match</v-btn>
						<v-checkbox hide-details v-model="filters.conf_med" class="ml-7" :label="filter_labels.conf_med"></v-checkbox>
						<v-checkbox hide-details v-model="filters.conf_low" class="ml-7" :label="filter_labels.conf_low"></v-checkbox>
					</div>
					<div v-show="filter_counts.leafs>0||filter_counts.nodes>0||filter_counts.alignable>0||filter_counts.nonalignable>0" style="display:flex; margin-bottom:10px; border-top:1px solid #0277BD; margin-top:20px;">
						<v-checkbox hide-details v-model="filters.leafs" class="ml-1" :label="filter_labels.leafs"></v-checkbox>
						<v-checkbox hide-details v-model="filters.nodes" class="ml-7" :label="filter_labels.nodes"></v-checkbox>
						<v-spacer/>
						<v-checkbox hide-details v-model="filters.alignable" class="ml-1" :label="filter_labels.alignable"></v-checkbox>
						<v-checkbox hide-details v-model="filters.nonalignable" class="ml-7" :label="filter_labels.nonalignable"></v-checkbox>
					</div>

					<div class="k-search-box-wrapper">
						<v-text-field
							v-model="search"
							prepend-inner-icon="fa fa-search"
							clearable
							clear-icon="fa fa-times-circle"
							label="Search"
							single-line
							hide-details
							outlined
							dense
							:background-color="'#fff'"
						></v-text-field>
					</div>
				</div>
			</div>
			<v-spacer/>
		</div>

		<div class="k-table-wrapper" :class="show_case_tree?'k-table-wrapper--tree-showing':''">
		<v-data-table
			:headers="headers"
			:items="filtered_dbrows"
			:disable-sort="true"
			:footer-props="footer_options"
			:options="table_options"
			:class="show_case_tree ? 'k-table k-table--tree-showing' : 'k-table'"
		>
			<template v-slot:item="{ item }"><tr :class="row_css(item)">
				<td class="k-table__sid-td" :data-sid="item.sid">{{ item.sid }}</td>
				<td class="k-table__db-desc-td">
					<div class="k-table-db-description" v-html="dbrow_cell(item)" @click="toggle_dbrow_visibility(item)"></div>
					<div v-if="adjacent_rows_hidden && item.show_status!='cropped'" class="mt-1"><b><a class="k-table-row--show-more-link" @click="show_rows_adjacent_to_dbrow_showing=!show_rows_adjacent_to_dbrow_showing"><span v-if="!show_rows_adjacent_to_dbrow_showing">Show</span><span v-if="show_rows_adjacent_to_dbrow_showing">Hide</span> adjacent rows</a></b></div>
				</td>
				<td class="k-table__case-items-td">
					<div class="k-table__case-item" :class="case_item_css(item,item.selected_case_item.identifier)">
						<div class="k-table-simscore">
							<v-icon small class="" color="green" @click="change_status_btn_clicked($event, item, item.selected_case_item.identifier, 'matched')">fas fa-check-circle</v-icon>
							<v-icon small class="" color="orange" @click="change_status_btn_clicked($event, item, item.selected_case_item.identifier, 'parked')">fas fa-question-circle</v-icon>
							<v-icon small class="mr-2" color="red" @click="change_status_btn_clicked($event, item, item.selected_case_item.identifier, 'nomatch')">fas fa-times-circle</v-icon>
							<span class="k-table-simscore-span" v-html="selected_simscore(item)"></span>
						</div>
						<v-icon v-if="item.show_status=='cropped'" class="mr-1" color="deep-purple lighten-1" @click="toggle_dbrow_visibility(item,'close_full')">fas fa-angle-right</v-icon>
						<v-icon v-if="item.show_status!='cropped'" class="mr-1" color="deep-purple lighten-1" @click="toggle_dbrow_visibility(item,'cropped')">fas fa-angle-down</v-icon>

						<div class="k-table-case-description"><v-icon class="k-table-case-description--tree-btn" small color="orange" @click.stop="open_case_tree_item(item.selected_case_item.identifier, item)">fas fa-tree</v-icon><div @click="toggle_dbrow_visibility(item)" v-html="selected_case_item_html(item)"></div></div>
					</div>

					<div v-if="item.show_status!='cropped'">
						<div v-for="(simscore, index) in item.simscores" class="k-table__case-item k-table__other-case-item" :class="case_item_css(item,simscore.case_guid)" v-if="show_full_status(item, simscore, index)">
							<div class="k-table-simscore">
								<v-icon small class="" color="green" @click="change_status_btn_clicked($event, item, simscore.case_guid, 'matched')">fas fa-check-circle</v-icon>
								<v-icon small class="" color="orange" @click="change_status_btn_clicked($event, item, simscore.case_guid, 'parked')">fas fa-question-circle</v-icon>
								<v-icon small class="mr-2" color="red" @click="change_status_btn_clicked($event, item, simscore.case_guid, 'nomatch')">fas fa-times-circle</v-icon>
								<span class="k-table-simscore-span" v-html="dbrow_simscore(item,index)"></span>
							</div>
							<v-icon class="mr-1" style="visibility:hidden">fas fa-angle-down</v-icon>
							<div class="k-table-case-description"><v-icon class="k-table-case-description--tree-btn" small color="#999" @click.stop="open_case_tree_item(simscore.case_guid, item)">fas fa-tree</v-icon><span v-html="dbrow_case_item(item,index)"></span></div>
						</div>
					</div>
					<div v-if="item.show_status=='close_full'" class="text-right mt-1"><b><a class="k-table-row--show-more-link" @click="toggle_dbrow_visibility(item,'all_full')">Show more suggested matches</a></b></div>
				</td>
			</tr></template>
		</v-data-table>
		</div>
	</v-card>
	<div class="k-case-tree-wrapper" v-show="show_case_tree">
		<v-btn text small color="#999" @click="close_case_tree" class="k-case-tree-close-btn"><v-icon>fas fa-times</v-icon></v-btn>
		<div class="k-case-tree-title"><v-icon>fas fa-grip-vertical</v-icon> CASE Framework Structure</div>
		<div class="k-case-tree-inner-wrapper">
			<v-treeview activatable active-class="k-case-tree_case-item--active"
				:active="case_tree_active"
				:open="case_tree_open"
				:items="cftree.children"
				item-key="tree_key"
				item-children="children"
				@update:active="case_tree_updated"
			>
				<!-- <template v-slot:prepend="{ item }">
					<v-icon class="pl-1" style="font-size:1.2em" v-if="!item.children.length==0">fas fa-map-marker</v-icon>
					<v-icon class="pl-1" style="font-size:1.2em" v-if="item.children.length==0">fas fa-map-marker-alt</v-icon>
				</template> -->
				<template v-slot:label="{ item }">
					<v-hover v-slot:default="{hover}"><div class="k-case-tree_case_item">
						<span v-show="hover" class="k-case-tree__asign_match"><v-icon color="green" @click="match_to_tree_item(item.cfitem.identifier)">fas fa-check-circle</v-icon></span>
						<span v-show="hover" class="k-case-tree__case_item_opener"><v-icon @click="open_case_network_item(item.cfitem.identifier)">fas fa-external-link-alt</v-icon></span>
						<span style="cursor:pointer"><b v-if="item.cfitem.humanCodingScheme!=null">{{item.cfitem.humanCodingScheme}}</b> <span v-html="item.cfitem.fullStatement"></span></span>
					</div></v-hover>
				</template>
			</v-treeview>
		</div>
	</div>

	<div class="k-saved-indicator" v-show="show_saved_indicator"><v-icon small class="mr-0">fas fa-check-circle</v-icon> Updates Saved</div>

	<div id="k-table-view-help" style="display:none">
		<p>The project table includes one row for each row in the Database Upload File you provided for the project.</p>
		<ul>
			<li>The <b>left side</b> of each table row includes your internal Database ID (DB ID) and the Code, Grades, and Description for the competency (e.g. standard) represented by the database row.</li>
			<li>The <b>right side</b> of each table row includes competencies (including Codes, Grades, and Descriptions) from the CASE framework that the tool’s machine learning (ML) algorithm has identified as possible matches to the corresponding database row.
				<ul>
					<li>The strength of each potential match is indicated by a “Similarity Score,” which is calculated by the ML algorithm and varies from 0.000 to 1.000.</li>
					<li>Initially, only the initial portion of the competency description for the top match (the one with the highest Similarity Score) is shown.</li>
					<li>Click the purple arrow (<v-icon color="deep-purple lighten-1">fas fa-angle-right</v-icon>), or one of the competency descriptions, to show the full descriptions on the left (database) and right (CASE) sides.</li>
					<li>If the ML algorithm detects additional CASE competencies that appear to be similarly close to the database competency, these additional CASE competencies will also be shown.</li>
					<li>Click “Show more suggested matches” to reveal additional possible matches identified by the ML algorithm.</li>
				</ul>
			</li>
			<li>After inspecting a row, click one of the following “status buttons” to record how the row should be categorized:
				<ul>
					<li><v-icon small color="green">fas fa-check-circle</v-icon>: designate this CASE competency as the correct <b>match</b> for the database row.</li>
					<li><v-icon small color="orange">fas fa-question-circle</v-icon>: “<b>Park</b>” this database row, indicating that you or someone else needs to come back later to consider it more carefully.</li>
					<li><v-icon small color="red">fas fa-times-circle</v-icon>: Explicitly designate this database row as one that you do not wish to match to a competency in this CASE framework. (All rows are implicitly designated as “unmatched” unless you explicitly designate a match, but explicitly marking “<b>No-Match</b>” can be helpful in keeping track of your project’s overall status.)</li>
					<li>Note that after clicking a status button to mark a row, you can always click the same status button again to reset the row to its initial “unmatched” status, or click a different button to, for example, mark as “matched” or “no-match” a row that you previously marked as “parked”.</li>
				</ul>
			</li>
			<li><b>“Batch matching”</b> can be accomplished in two ways:
				<ul>
					<li>If the ML algorithm has identified one or more rows as “high confidence” matches, you can click the “BATCH MATCH” button in the light-blue filters area of the window to mark ALL of the high-confidence matches as correct matches. (After clicking the button, the tool will show a confirmation dialog before proceeding with the batch match process).</li>
					<li>To batch-mark rows more carefully, hold the <b>shift key</b> down when clicking the green status buttons for any row to mark <b>all rows currently visible in the browser window</b> as a correct match. (You can also hold the shift key down while clicking an orange or red button for any row to mark all currently-visible rows as “parked” or “unmatched”.)</li>
				</ul>
			</li>
			<li>Rows are <b>color-coded</b> as follows:
				<ul>
					<li><span class="k-table-row--batch-matchable">YELLOW:</span> The tool’s ML algorithm has high confidence that the top-listed CASE competency is, in fact, the correct match for this database row (see below for exactly what we mean by “high confidence”).</li>
					<li><span class="k-table-row--close-match">BROWN:</span> The tool’s ML algorithm has “medium confidence” that the top-listed CASE competency is, in fact, the correct match for this database row (see below for exactly what we mean by “medium confidence”).</li>
					<li><span class="k-table-row--matched">GREEN:</span> A match for this database row has been explicitly specified.</li>
					<li><span class="k-table-row--parked">ORANGE:</span> This database row has been “parked” (see above).</li>
					<li><span class="k-table-row--nomatch">RED:</span> This database row has been explicitly designated as “no-match” (see above).</li>
					<li>WHITE (no background color): This database row has not been explicitly marked as matched, parked, or no-match, and the ML algorithm does not have a strong “guess” about which CASE competency goes with the database row.</li>
				</ul>
			</li>
			<li>You can use the following <b>filters</b> to limit which rows are visible in the table. Strategic use of filters is key to efficiently identifying matches for all relevant rows in your database upload file.
				<ul>
					<li><b>“Unmatched”, “Matched”, “Parked”, “No-match”:</b> show or hide items currently marked as any of these statuses. For example, once you start the process of identifying matches, it is often useful to hide items you’ve already marked, so you can focus on the items you still have to mark.</li>
					<li><b>“High confidence”, “Medium confidence”, “Low confidence”:</b> show or hide unmatched items for which the tool’s ML algorithm has high, medium, or low confidence (as described above and below) that it’s identified the correct match.</li>
					<li><b>“Leafs”, “Nodes”:</b> if in your database import file you specified whether each database item is a “node” (meaning the item has “child” items) or a “leaf” (meaning it doesn’t have children; i.e. it is a “terminal” item in the standards tree), use these filters to show or hide leafs and nodes. For example, it is often more important to identify matches for leafs, since resources are more often aligned to these standards, so you may wish to hide (and therefore ignore) the node standards.</li>
					<li><b>“Alignable”, “Non-Alignable”:</b> if your database import file explicitly specifies whether each standard is “alignable”, these filters will be active.</li>
					<li><b>Search field:</b> Enter text in the search box to instantly filter down to only rows whose database descriptions and/or top-matching CASE items include ALL words entered here.</li>
				</ul>
			</li>
			<li><b>“Show adjacent rows”</b> When you have some class(es) of rows hidden using filters and are examining visible rows to try to determine best matches, it is sometimes useful to reveal adjacent rows (for example, for the standard you’re currently evaluating, the previous standard from your database import file might be this standard’s sibling or parent and may be already matched, so you may want to see which CASE item the sibling or parent was matched to). To reveal these adjacent rows, click to view the row’s CASE matches, then click the “Show adjacent rows” link that you’ll see under the database item’s description.</li>
			<li><b>Keyboard shortcuts:</b> Use the right arrow key to page forward in the table, and the left arrow key to page backward.</li>
			<li><b>CASE Tree:</b> Click the “tree” icon next to any CASE item to reveal that item in the CASE tree structure, which will appear on the right side of the window. Once the tree is open, you can browse to view any other CASE items in the tree. Furthermore, hovering the mouse cursor over any CASE item in the tree reveals two additional options, allowing you to open and view the item’s full representation in CASE Network, or to designate the CASE item as the match for the currently-open database row.</li>
			<li><b>“High” and “Medium” confidence</b> items:<ul>
				<li>High confidence rows will be shown in yellow. For it to have high confidence, the algorithm must see that:<ul>
					<li>a) the CASE item’s “human-readable code” (e.g. “RL.6.4”) has an exact match with a database item (ignoring uniform prefixes—e.g. “RL.6.4” will match to “ELA-Literacy.RL.6.4”), </li>
					<li>OR b) the similarity score for the CASE item-database item match is 1.0 (a perfect match), </li>
					<li>AND c) there is only a single database item that conditions (a) or (b) both hold for (that is, if the CASE item’s code or description match <i>multiple</i> database items, the algorithm can’t know which of the database items to match; but see below for an exception to this rule).</li>
					<li>Additional high confidence situation: As just noted, if multiple exact matches exist for the DB row based on description similarities, the tool will normally say that it doesn’t know which is the correct match.  However, if for one of the matching CASE items, the item directly “underneath” the CASE item is an exact match with database item directly “underneath” the item in question (where “underneath” means “is a child of” for the CASE items and “appears directly after in the original database import file” for the database items), the tool will assume, with high confidence, that this item is the right match.</li>
				</ul></li>
				<li>Medium confidence rows will be shown in brown. For it to have medium confidence, the algorithm must see that:<ul>
					<li>a) the similarity score for the top-matching database item to the CASE item is at least 0.92, </li>
					<li>AND b) the similarity score for the top-matching database item is at least 0.02 higher than the similarity score for the next-closest potential match, </li>
					<li>AND c) the standard description includes at least 50 characters (for short descriptions, we get lots of spurious matches).</li>
				</ul></li>
				<li>For rows shown with a plain white background, the CASE item shown at the top of the list is the best-matching standard (based on similarity scores), but the conditions listed above were not met, so the tool is not willing to “make a call” on the veracity of the match.</li>
			</ul></li>
			<li><b>Reset All Matches button:</b> Click this button at any time to clear all matched, parked, and no-match designation and start the process over. (This is not undoable).</li>
			<li><b>Export Matches button:</b> Once you’ve identified all the matches you care about, click this button to export and download a CSV or TSV file with the matches. The export file will include only two columns:<ul>
				<li>STANDARD_ID: Your internal database standard ID</li>
				<li>CASE_URI: The CASE Network URI for the corresponding standard in the CASE framework</li>
			</ul>This should be all you need to update your database so you can start “speaking in CASE”!</li>
		</ul>
	</div>

</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import draggable from 'vuedraggable'

export default {
	components: { draggable },
	data() { return {
		dbrow_showing: null,
		show_rows_adjacent_to_dbrow_showing: false,
		filters: {},
		filter_counts: {
			leafs: 0,
			nodes: 0,
			alignable: 0,
			nonalignable: 0,
			unmatched: 0,
			matched: 0,
			parked: 0,
			nomatch: 0,
			conf_high: 0,
			conf_med: 0,
			conf_low: 0,
		},
		filter_labels: {
			leafs: '',
			nodes: '',
			alignable: '',
			nonalignable: '',
			unmatched: '',
			matched: '',
			parked: '',
			nomatch: '',
			conf_high: '',
			conf_med: '',
			conf_low: '',
		},
		show_case_tree: false,
		case_tree_open: [],
		case_tree_active: [],
		case_network_iframe_url: '',
		last_clicked_guid: '',
		search: '',
		footer_options: {
			itemsPerPageOptions: [10,20,50,100,250],
		},
		table_options: {
			itemsPerPage: 20,
			page: 1,
		},
		headers: [
			{
				text: 'DB ID',
				align: 'center',
			},
			{
				text: 'DB Code/Grades/Competency Description',
				align: 'left',
				sortable: true,
			},
			{
				text: '             Similarity Score  /  CASE Standard Code/Grades/Competency Description',
				align: 'left',
				sortable: true,
			}
		]
	}},
	watch: {
	},
	computed: {
		...mapState(['project', 'cfdocument', 'cfitems', 'cftypes', 'cftree', 'tree_key_hash', 'dbrows', 'show_saved_indicator']),
		// ...mapGetters(['has_links']),
		filtered_dbrows() {
			U.local_storage_set('cgrtool-filters', this.filters)

			// reset filter_counts
			for (let filter in this.filters) {
				this.filter_counts[filter] = 0
			}

			let dbsr_low = -10
			let dbsr_high = -10
			if (this.show_rows_adjacent_to_dbrow_showing && !empty(this.dbrow_showing)) {
				dbsr_low = this.dbrow_showing.order - 1
				dbsr_high = this.dbrow_showing.order + 1
			}

			// search field
			let search_val = ''
			let search_sid = false
			if (!empty(this.search)) {
				search_val = this.search.toLowerCase()
				if (!isNaN(search_val*1)) {
					search_sid = true
				}
			}

			// use a filter to pull out dbrows we want to show
			// note that this procedure also sets filter_counts, so we need to individually test every filter condition
			let sorted_dbrows = this.dbrows.filter((dbrow) => {
				// RETURN FALSE TO HIDE THE ITEM
				let rv = true

				let top_simscore = dbrow.top_simscore.descscore_raw

				// if leafs is false and the dbrow is a leaf, HIDE
				if (dbrow.is_leaf === true) {
					++this.filter_counts.leafs
					if (this.filters.leafs == false) rv = false
				}

				// if nodes is false and the dbrow is not a leaf, HIDE
				if (dbrow.is_leaf === false) {
					++this.filter_counts.nodes
					if (this.filters.nodes == false) rv = false
				}

				// if alignable is false and the dbrow is alignable, HIDE
				if (dbrow.is_alignable === true) {
					++this.filter_counts.alignable
					if (this.filters.alignable == false) rv = false
				}

				// if nonalignable is false and the dbrow is not alignable, HIDE
				if (dbrow.is_alignable === false) {
					++this.filter_counts.nonalignable
					if (this.filters.nonalignable == false) rv = false
				}

				// determine confidence
				let conf = ''
				if (this.dbrow_high_confidence(dbrow)) conf = 'high'
				else if (this.dbrow_med_confidence(dbrow)) conf = 'med'
				else if (dbrow.status == 'unmatched') conf = 'low'

				// if filters.conf_high is false and the dbrow is high-conf, HIDE
				if (conf == 'high') {
					++this.filter_counts.conf_high
					if (this.filters.conf_high == false) rv = false
				}

				// if filters.conf_med is false and the dbrow is med-conf, HIDE
				if (conf == 'med') {
					++this.filter_counts.conf_med
					if (this.filters.conf_med == false) rv = false
				}

				// if filters.conf_low is false and the dbrow is low-conf, HIDE
				if (conf == 'low') {
					++this.filter_counts.conf_low
					if (this.filters.conf_low == false) rv = false
				}

				// if unmatched is false and the dbrow's status is not 'unmatched', HIDE
				if (dbrow.status == 'unmatched') {
					++this.filter_counts.unmatched
					if (this.filters.unmatched == false) rv = false
				}

				// if matched is false and the dbrow's status is not 'matched', HIDE
				if (dbrow.status == 'matched') {
					++this.filter_counts.matched
					if (this.filters.matched == false) rv = false
				}

				// if parked is false and the dbrow's status is not 'parked', HIDE
				if (dbrow.status == 'parked') {
					++this.filter_counts.parked
					if (this.filters.parked == false) rv = false
				}

				// if nomatch is false and the dbrow's status is not 'nomatch', HIDE
				if (dbrow.status == 'nomatch') {
					++this.filter_counts.nomatch
					if (this.filters.nomatch == false) rv = false
				}

				// if row has made it through other filters and user has entered something in the search string, look for it
				if (rv == true && search_val != '') {
					// if we have a search_val, rv is false unless it matches the search string
					rv = false

					// if a number, search the sid
					if (search_sid) {
						// if the entered number is in the value, return true
						if (dbrow.sid.indexOf(search_val) > -1) {
							rv = true
						}

					} else {
						// search description and fullStatement
						if (!empty(dbrow.description_lc) && dbrow.description_lc.indexOf(search_val) > -1) rv = true
						if (!empty(dbrow.selected_case_item) && !empty(dbrow.selected_case_item.fullStatement_lc) && dbrow.selected_case_item.fullStatement_lc.indexOf(search_val) > -1) rv = true

						// search codes
						if (!empty(dbrow.code_lc) && dbrow.code_lc.indexOf(search_val) > -1) rv = true
						if (!empty(dbrow.selected_case_item) && !empty(dbrow.selected_case_item.humanCodingScheme_lc) && dbrow.selected_case_item.humanCodingScheme_lc.indexOf(search_val) > -1) rv = true
					}
				}

				// if the row is dbrow_showing, or is within dbsr_low and dbsr_high, show it, regardless of above considerations
				if (dbsr_low > -10 && dbrow.order >= dbsr_low && dbrow.order <= dbsr_high) {
					rv = true
				}

				return rv
			})

			this.filter_labels.leafs = sr('Leafs ($1)', this.filter_counts.leafs)
			this.filter_labels.nodes = sr('Nodes ($1)', this.filter_counts.nodes)
			this.filter_labels.alignable = sr('Alignable ($1)', this.filter_counts.alignable)
			this.filter_labels.nonalignable = sr('Non-Alignable ($1)', this.filter_counts.nonalignable)
			this.filter_labels.conf_high = sr('High confidence ($1)', this.filter_counts.conf_high)
			this.filter_labels.conf_med = sr('Medium confidence ($1)', this.filter_counts.conf_med)
			this.filter_labels.conf_low = sr('Low confidence ($1)', this.filter_counts.conf_low)
			this.filter_labels.unmatched = sr('Unmatched ($1)', this.filter_counts.unmatched)
			this.filter_labels.matched = sr('Matched ($1)', this.filter_counts.matched)
			this.filter_labels.parked = sr('Parked ($1)', this.filter_counts.parked)
			this.filter_labels.nomatch = sr('No-Match ($1)', this.filter_counts.nomatch)

			// reset table page if we're now out of range
			let last_page = Math.ceil(sorted_dbrows.length / this.table_options.itemsPerPage)
			if (this.table_options.page > last_page) {
				this.table_options.page = last_page
			}

			return sorted_dbrows
		},
		// this computed var returns true if a row is "showing" (i.e. the whole db standard description is showing) and that row has adjacent rows that are currently hidden by the filters
		adjacent_rows_hidden() {
			if (empty(this.dbrow_showing)) return false

			let i = this.dbrow_showing.order

			// check previous row unless the currently-showing row is the first one
			if (i != 0) {
				if ($(sr('.k-table__sid-td[data-sid=$1]', this.dbrows[i-1].sid)).length == 0) {
					return true
				}
			}

			// check next row unless the currently-showing row is the very last one
			if (i != this.dbrows.length-1) {
				if ($(sr('.k-table__sid-td[data-sid=$1]', this.dbrows[i+1].sid)).length == 0) {
					return true
				}
			}

			return false
		},
		export_enabled() {
			return this.project.case_framework_cached_at > 0 && this.project.db_uploaded_at > 0 && this.project.status_summary.matched > 0
		},
	},
	created() {
		// use default filters (allowing us to add additional filters later), overridden by previous settings by user
		this.filters = Object.assign({}, {
			leafs: true,
			nodes: true,
			alignable: true,
			nonalignable: true,
			conf_high: true,
			conf_med: true,
			conf_low: true,
			unmatched: true,
			matched: true,
			parked: true,
			nomatch: true,
		}, U.local_storage_get('cgrtool-filters', {}))
	},
	mounted() {
		// keyboard shortcuts
		$(window).off('keyup')
		$(window).on('keyup', (event) => {
			// console.log(event.keyCode, event.code, event.key, event)
			// handle code (as opposed to 'key', since 'code' isn't altered by the modifier keys) or keyCode ('code' is the new standard, but MS browsers don't yet support it)
			// right arrow: go to next page of results
			if (event.code == 'ArrowRight' || event.keyCode == 39) {
				let last_page = Math.ceil(this.filtered_dbrows.length / this.table_options.itemsPerPage)
				if (this.table_options.page == last_page) {
					this.$inform({text:'You are already viewing the last page of filtered rows.', snackbarTimeout:2000})
				} else {
					this.table_options.page++
				}

			// left arrow: go to previous page of results
			} else if (event.code == 'ArrowLeft' || event.keyCode == 37) {
				if (this.table_options.page == 1) {
					this.$inform({text:'You are already viewing the first page of filtered rows.', snackbarTimeout:2000})
				} else {
					this.table_options.page--
				}
			}
		})
	},
	methods: {
		go_to_projects() {
			vapp.go_to_projects()
		},

		dbrow_cell(dbrow) {
			let grade_range = '-'
			if (!empty(dbrow.grade_low)) {
				grade_range = dbrow.grade_low
			}
			if (!empty(dbrow.grade_high) && dbrow.grade_high != dbrow.grade_low) {
				if (!empty(grade_range)) grade_range += '-' + dbrow.grade_high
				else grade_range = dbrow.grade_high
			}

			let s = ''
			if (dbrow.is_leaf === false) s = '<i class="fas fa-project-diagram"></i> '
			if (!empty(dbrow.code)) s += sr('<b>$1</b> ', dbrow.code)
			s += sr('[$1] ', grade_range)

			if (dbrow.is_alignable === false) {
				s += '<span class="k-table__dbrow--non-alignable">N-A</span> '
			}

			if (!empty(dbrow.description)) s += dbrow.description

			return s
		},

		selected_simscore(dbrow) {
			if (empty(dbrow.selected_case_item)) return '—'
			let simscore = dbrow.simscores.find(o=>o.case_guid == dbrow.selected_case_item.identifier)
			if (empty(simscore)) return '—'

			let rv = simscore.descscore

			if (dbrow.codescore_raw == 1) rv += '*'

			// highlight unmatched items with multiple top scores
			if (dbrow.status == 'unmatched' && dbrow.multiple_tops == true) {
				rv = sr('<i><b>$1</b></i>', rv)
			}

			return rv
		},

		dbrow_simscore(dbrow, index) {
			return dbrow.simscores[index].descscore
		},

		selected_case_item_html(dbrow) {
			let case_item = dbrow.selected_case_item
			if (empty(case_item.identifier)) return '—'

			return this.case_item_html(case_item)
		},

		dbrow_case_item(dbrow, index) {
			let case_item = this.cfitems[dbrow.simscores[index].case_guid]
			if (empty(case_item) || empty(case_item.identifier)) return '—'

			return this.case_item_html(case_item)
		},

		case_item_html(case_item) {
			let s = ''
			// show branch icon for non-leafs
			if (case_item.CFItemType != 'Standard') s = '<i class="fas fa-project-diagram"></i> '

			// human coding scheme
			if (!empty(case_item.humanCodingScheme)) s = sr('<b>$1</b> ', case_item.humanCodingScheme)

			// educationLevel (grades)
			let grade_range = '-'
			if (!empty(case_item.educationLevel) && !empty(case_item.educationLevel[0])) {
				let grade_low = case_item.educationLevel[0]
				if (!isNaN(grade_low*1)) grade_low *= 1
				if (grade_low == 'KG') grade_low = 'K'

				let grade_high = case_item.educationLevel[case_item.educationLevel.length-1]
				if (!isNaN(grade_high*1)) grade_high *= 1
				if (grade_high == 'KG') grade_high = 'K'

				if (!empty(grade_low)) {
					grade_range = grade_low
				}
				if (!empty(grade_high) && grade_high != grade_low) {
					if (!empty(grade_range)) grade_range += '-' + grade_high
					else grade_range = grade_high
				}
			}
			s += sr('[$1] ', grade_range)

			// note copies
			if (!empty(case_item.is_copy_of)) {
				s += '<span class="k-table__case-item--copy-of">COPY</span> '
			}

			// full statement
			if (!empty(case_item.fullStatement)) s += case_item.fullStatement

			return s
		},

		row_css(dbrow) {
			let cl = ''
			if (dbrow.show_status != 'cropped') cl = 'k-table-row--show-all '

			if (dbrow.status != 'unmatched') {
				cl += 'k-table-row--' + dbrow.status
			} else if (this.dbrow_high_confidence(dbrow)) {
				cl += 'k-table-row--batch-matchable'
			} else if (this.dbrow_med_confidence(dbrow)) {
				cl += 'k-table-row--close-match'
			}

			return cl
		},

		matchable_stats() {
			let o = {
				total: 0,
				matched: 0,
				parked: 0,
				nomatch: 0,
				sure_match: 0,
				close_match: 0,
				unknown: 0,
			}
			for (let dbrow of this.dbrows) {
				if (dbrow.simscores.length > 0) {
					o.total++
					if (dbrow.status != 'unmatched') {
						o[dbrow.status]++
					} else if (this.dbrow_high_confidence(dbrow)) {
						o.sure_match++
					} else if (this.dbrow_med_confidence(dbrow)) {
						o.close_match++
					} else {
						o.unknown++
					}
				}
			}

			for (let key in o) {
				if (key == 'total') continue
				o[key] = sr('$1 ($2%)', o[key], Math.round(o[key]/o.total*100))
			}

			this.$alert(sr('<pre>$1</pre>', JSON.stringify(o, null, 4)))
		},

		toggle_dbrow_visibility(dbrow, val) {
			if (val === undefined) {
				if (dbrow.show_status == 'cropped') {
					val = 'close_full'
				} else {
					val = 'cropped'
				}
			}

			// if we're opening the dbrow, close previously-open dbrow
			if (val != 'cropped') {
				if (dbrow != this.dbrow_showing) {
					if (!empty(this.dbrow_showing)) {
						this.$store.commit('set', [this.dbrow_showing, 'show_status', 'cropped'])
					}
					this.dbrow_showing = dbrow
				}
			} else {
				// else set dbrow_showing to null, because nothing is showing, and clear show_rows_adjacent_to_dbrow_showing
				this.dbrow_showing = null
				this.show_rows_adjacent_to_dbrow_showing = false
			}

			this.$store.commit('set', [dbrow, 'show_status', val])
		},

		// this fn is called to determine if each case item *other than the currently-top item* should be shown
		show_full_status(dbrow, simscore, simscore_index) {
			// if show_status is 'cropped' or there isn't a selected_case_item, always return false
			if (dbrow.show_status == 'cropped' || empty(dbrow.selected_case_item)) return false

			// always skip the currently-top item; that one is shown via a different html block
			if (simscore.case_guid == dbrow.selected_case_item.identifier) return false

			// if show_status is 'all_full', always return true
			if (dbrow.show_status == 'all_full') return true

			// otherways show_status is 'close_full', so evaluate...
			let top_simscore = dbrow.simscores.find(o=>o.case_guid == dbrow.selected_case_item.identifier)
			if (empty(top_simscore)) return false

			// if this row is >= top_simscore, show it
			if (simscore.descscore_raw >= top_simscore.descscore_raw) return true

			// if ... show it
			if (simscore.descscore_raw >= top_simscore.descscore_raw - .02) return true

			return false
		},

		case_item_css(dbrow, case_guid) {
			if (this.last_clicked_guid == case_guid) {
				return 'k-last-case-item-clicked'
			}
		},

		open_case_tree_item(case_guid, dbrow) {
			let case_item = this.cfitems[case_guid]

			// activate this item anywhere it appears in the case_tree
			this.case_tree_active = case_item.tree_keys

			// open the item's ancestors
			let ancestors = []
			for (let node of case_item.tree_nodes) {
				let temp_node = node
				while (!empty(temp_node.parent_node)) {
					ancestors.push(temp_node.parent_node.tree_key)
					temp_node = temp_node.parent_node
				}
			}
			this.case_tree_open = ancestors

			this.last_clicked_guid = case_item.identifier

			// make sure the tree is showing
			this.show_case_tree = true

			// toggle the dbrow open, if a dbrow is specified?? (not doing this for now)
			// if (!empty(dbrow)) {
			// 	if (dbrow.show_status == 'cropped') {
			// 		this.toggle_dbrow_visibility(dbrow, 'close_full')
			// 	}
			// }
		},

		case_tree_updated(arr) {
			// this is called by an event in the v-treeview component when the user clicks to activate an item in the tree
			// arr will contain an array of tree keys (there should only be one). set last_clicked_guid to point to the case_item for this tree key
			if (arr.length == 0) {
				this.last_clicked_guid = null
			} else {
				this.last_clicked_guid = this.tree_key_hash[arr[0]].cfitem.identifier
			}
		},

		close_case_tree() {
			this.show_case_tree = false
			// clear case_tree_active and last_clicked_guid
			this.case_tree_active = []
			this.last_clicked_guid = ''
		},

		open_case_network_item(case_guid) {
			let case_item = this.cfitems[case_guid]
			// TODO: I'd like to open directly to 'tree view'
			let uri = case_item.uri

			window.open(uri, 'case_network_window', 'menubar=false,toolbar=false,status=false,width=800,height=800')
		},

		match_to_tree_item(case_guid) {
			// user clicks icon in CASE tree to match the selected item in the tree to the currently-open row

			// if no row is open, show an alert
			if (empty(this.dbrow_showing)) {
				this.$alert('To match this CASE standard to a DB Row, open the DB Row in the table (by clicking the purple <i class="fas fa-angle-right"></i> icon).')
				return
			}

			this.change_status(this.dbrow_showing, case_guid, 'matched')
		},

		table_search_filter(value, search, item) {
			// TODO: move this to filter, so show adjacent rows will work

			// value is the value of the column (we can ignore this); search is the search string (could be empty)
			// RETURN FALSE TO HIDE THE ITEM

			// if search is empty, always return true, so the item will SHOW
			if (empty(search)) return true

			search = search.toLowerCase()

			// if a number, search the sid
			if (!isNaN(search*1)) {
				// if the entered number is in the value, return true
				if (item.sid.indexOf(search) > -1) return true
			}

			// search description and fullStatement
			if (!empty(item.description_lc) && item.description_lc.indexOf(search) > -1) return true
			if (!empty(item.selected_case_item.fullStatement_lc) && item.selected_case_item.fullStatement_lc.indexOf(search) > -1) return true

			// search codes
			if (!empty(item.code_lc) && item.code_lc.indexOf(search) > -1) return true
			if (!empty(item.selected_case_item.humanCodingScheme_lc) && item.selected_case_item.humanCodingScheme_lc.indexOf(search) > -1) return true

			// TODO: search grades?
			// TODO: search CASE GUIDs?

			// if we get to here return false
			return false
		},

		change_status_btn_clicked($event, dbrow, case_guid, status) {
			// if user had shift key down when they clicked...
			if (!empty($event) && $event.shiftKey && !empty(dbrow.selected_case_item) && dbrow.selected_case_item.identifier == case_guid) {
				// no shift-clicking allowed when you're toggling an item -- i.e. when the item was already the status you clicked on
				if (dbrow.status == status) {
					console.log('no shift-clicking allowed when you’re toggling an item')
					return
				}

				let status_display
				if (status == 'matched') status_display = 'Matched'
				else if (status == 'nomatch') status_display = 'No-Match'
				else if (status == 'parked') status_display = 'Parked'

				let prev_order = -1
				let prev_sid
				let gaps = []
				let num_items = 0
				$('.k-table__sid-td').each((i, el) => {
					// get the sid and the dbrow
					let sid = $(el).attr('data-sid')
					let dbrow = this.dbrows.find(o=>o.sid == sid)

					if (prev_order > -1 && dbrow.order != prev_order+1) {
						gaps.push([prev_sid, sid])
					}
					prev_order = dbrow.order
					prev_sid = sid
					++num_items
				})

				if (gaps.length > 0) {
					let gaps_str = '<ul class="mt-2 mb-2">'
					for (let gap of gaps) {
						gaps_str += sr('<li>Database IDs <b>$1</b> and <b>$2</b></li>', gap[0], gap[1])
					}
					gaps_str += '</ul>'

					this.$confirm({
					    title: 'Batch Process',
					    text: sr('<b>Note:</b> The currently-showing database rows include one or more “gaps”, between the following pairs of Database IDs: $1 This may indicate that additional rows in the “gap(s)” also need to be marked as $2, or that some currently-showing rows <i>shouldn’t</i> be marked as $2.<br><br>Are you sure you want to set <b>all $3 currently-showing rows</b> to status <b>$2</b>?', gaps_str, status_display, num_items),
					    acceptText: 'Yes — Batch Process',
					    cancelText: 'Cancel',
						dialogMaxWidth: 650
					}).then(y => {
						this.shift_change_status(status, status_display)
						this.shift_click_status_warning_shown = true
					}).catch(n=>{console.log(n)}).finally(f=>{});

					return
				}

				// if we already showed the generic warning once, don't show it again
				if (this.shift_click_status_warning_shown) {
					this.shift_change_status(status, status_display)
					return
				}

				this.$confirm({
				    title: 'Batch Process',
				    text: sr('Are you sure you want to set <b>all $1 currently-showing rows</b> to status <b>$2</b>?', num_items, status_display),
				    acceptText: 'Yes — Batch Process',
				    cancelText: 'Cancel',
					dialogMaxWidth: 650
				}).then(y => {
					this.shift_change_status(status, status_display)
					this.$alert('Note: this warning will not be shown again; the next time you shift-click a status button, the batch process will run automatically.')
					this.shift_click_status_warning_shown = true
				}).catch(n=>{console.log(n)}).finally(f=>{});

			} else {
				this.change_status(dbrow, case_guid, status)
			}
		},

		// batch-row processing for when user holds shift key down
		shift_change_status(status, status_display) {
			// use this jq selector to go through all currently-showing rows
			let num_changed = 0
			$('.k-table__sid-td').each((i, el) => {
				// get the sid and the dbrow
				let sid = $(el).attr('data-sid')
				let dbrow = this.dbrows.find(o=>o.sid == sid)

				// we can always batch-change when the user clicks nomatch or parked
				if (status == 'nomatch' || status == 'parked') {
					this.$store.commit('set', [dbrow, 'status', status])
					++num_changed

				// for matches, only set matches when there's actually a selected_case_item
				} else if (!empty(dbrow.selected_case_item)) {
					this.$store.commit('set', [dbrow, 'status', status])
					++num_changed
				}
			})

			// call process_simscores_dynamic to see if we can update this item's parent, then save
			vapp.process_simscores_dynamic()
			this.$store.dispatch('save_status')

			// make sure no node is active
			this.case_tree_active = []
			this.last_clicked_guid = ''

			// clear show_rows_adjacent_to_dbrow_showing flag
			this.show_rows_adjacent_to_dbrow_showing = false

			this.$inform(sr('$1 rows set to status <b>$2</b>', num_changed, status_display))
		},

		change_status(dbrow, case_guid, status, batching) {
			let selected_case_item = null
			let crop_row = false

			// if (we're not batching) and (the row already had this status) and (the selected guid matches this guid (or it was previously marked as "nomatch")),
			if (batching !== true && dbrow.status == status && (status == 'nomatch' || case_guid == dbrow.selected_case_item.identifier)) {
				// switch back to unmatched
				status = 'unmatched'
				// set selected_case_item to whatever the automatic top match was
				selected_case_item = this.cfitems[dbrow.top_simscore.case_guid]

			// else if status is nomatch, there's no selected_case_item
			} else if (status == 'nomatch') {
				selected_case_item = {}
				// make sure this row is collapsed
				crop_row = true

			// else set to the clicked case item
			} else {
				selected_case_item = this.cfitems[case_guid]
				// make sure this row is collapsed
				crop_row = true
			}

			// if the row was previously matched, warn user before changing to a different status
			if (dbrow.status == 'matched') {
				let msg
				// if new status is also matched, we're switching to a new one...
				if (status == 'matched') {
					msg = 'This database standard was previously marked as matched to a different CASE standard. Are you sure you want to change the match to this new CASE standard?'
				} else {
					msg = 'This database standard was previously marked as matched to a CASE standard. Are you sure you want to unmatch it?'
				}
				this.$confirm({
				    title: 'Are you sure?',
				    text: msg,
				}).then(y => {
					this.finish_status_change(dbrow, status, selected_case_item, crop_row)
				}).catch(n=>{console.log(n)}).finally(f=>{});

			} else {
				this.finish_status_change(dbrow, status, selected_case_item, crop_row)
			}
		},

		finish_status_change(dbrow, status, selected_case_item, crop_row) {
			// if we're changing status on the first row, and it was showing (not cropped), we want to show (uncrop) the new top row
			let changing_top_row = (dbrow == this.filtered_dbrows[0])

			this.$store.commit('set', [dbrow, 'selected_case_item', selected_case_item])
			this.$store.commit('set', [dbrow, 'status', status])

			if (crop_row) {
				if (dbrow.show_status != 'cropped' && dbrow != this.filtered_dbrows[0]) {
					this.toggle_dbrow_visibility(this.filtered_dbrows[0], 'close_full')
				} else {
					this.toggle_dbrow_visibility(dbrow, 'cropped')
				}
			}

			// call process_simscores_dynamic to see if we can update this item's parent, then save
			vapp.process_simscores_dynamic()
			this.$store.dispatch('save_status')

			// clear show_rows_adjacent_to_dbrow_showing flag
			this.show_rows_adjacent_to_dbrow_showing = false

			// make sure the node isn't active
			this.case_tree_active = []
			this.last_clicked_guid = ''
		},

		reset_all_matches() {
			this.$confirm({
			    text: 'This will reset all matched, parked, and no-match standards back to “unmatched” status. Are you sure?',
			    acceptText: 'Reset',
			    cancelText: 'Cancel'
			}).then(y => {
				for (let dbrow of this.dbrows) {
					this.$store.commit('set', [dbrow, 'status', 'unmatched'])
				}

				// reset the "batch shown" flag
				U.local_storage_set('cgrtool-batch-shown', false)

				// after we're done doing this, reload window to refresh duplicate matching algorithm
				this.$store.dispatch('save_status').then(()=>document.location.reload())

			}).catch(n=>{}).finally(f=>{});
		},

		dbrow_high_confidence(dbrow) {
			// we only return true here for rows whose current status is unmatched
			if (dbrow.status != 'unmatched') return false

			// don't batch-match rows with multiple tops (i.e. when multiple CASE standards are "tied" at the top of the simscore list)
			if (dbrow.multiple_tops == true) return false

			// at this point, batch match if the top match is 1.0
			if (dbrow.top_simscore.descscore_raw == 1.0) return true

			// also batch match if the top match's codes match (at least at the end -- i.e. allow "ELA-Literacy.RL.K.2" match with "RL.K.2")
			if (dbrow.top_simscore.codescore_raw == 1) return true

			// if we get to this point return false
			return false
		},

		dbrow_med_confidence(dbrow) {
			// we only return true here if (the row's current status is unmatched) and (the row isn't matched with high confidence)
			if (dbrow.status != 'unmatched' || this.dbrow_high_confidence(dbrow)) return false

			let ss0 = dbrow.simscores[0]
			let ss1 = dbrow.simscores[1]
			if (!empty(ss0) && !empty(ss1) && ss0.descscore_raw > 0 && ss1.descscore_raw > 0) {
				// if description is >= 50 characters and top match is > 0.92 and > .02 of next-highest match, shade a different color
				// (for short descriptions, we get lots of spurious matches)
				if (!empty(dbrow.description) && dbrow.description.length >= 50 && ss0.descscore_raw > 0.92 && (ss0.descscore_raw - ss1.descscore_raw) > 0.02) {
					return true
				}
			}
			return false
		},

		batch_match_count() {
			let count = 0
			for (let dbrow of this.dbrows) {
				if (this.dbrow_high_confidence(dbrow)) {
					console.log('batch_match: ' + dbrow.sid)
					++count
				}
			}

			return count
		},

		batch_match() {
			U.local_storage_set('cgrtool-batch-shown', true)

			let count = this.batch_match_count()

			if (count == 0) {
				this.$alert('Our algorithms do not currently detect any database-CASE pairs that can be automatically matched.')
				return
			}

			let html = sr('This operation will mark as “matched” the <b>$1</b> database-CASE pair(s) where our algorithms are <b>highly confident</b> of having identified a correct match. These pairs are shaded yellow in the table.<br><br><b>Please note:</b> a safer way to proceed is to review standards in the table one page at a time, using the filters to control what’s shown in the current page, and <i>shift-click</i> on the status buttons <nobr>(<i class="fas fa-check-circle"></i> <i class="fas fa-question-circle"></i> <i class="fas fa-times-circle"></i>)</nobr> to batch process currently-showing standards. See the Documentation for more information on this method.', count)
			// Click “CANCEL” if you’d like to review these automatic matches in the table before proceeding.
			this.$confirm({
				title: 'Batch Match Operation',
			    text: html,
			    acceptText: 'Batch Match!',
			    cancelText: 'Cancel'
			}).then(y => {
				for (let dbrow of this.dbrows) {
					if (this.dbrow_high_confidence(dbrow)) {
						this.$store.commit('set', [dbrow, 'status', 'matched'])
					}
				}
				this.$store.dispatch('save_status')
				vapp.process_simscores_dynamic()

				let new_count = this.batch_match_count()
				if (new_count > 0) {
					let html = sr('Now that those $1 database-CASE pairs have been matched, our algorithms can automatically pair an additional <b>$2</b> database items with CASE items (based on parent-child relationships in the CASE hierarchy). Would you like to batch-match these items as well?', count, new_count)
					this.$confirm({
					    text: html,
					    acceptText: 'Re-Run Batch Match Process',
					    cancelText: 'Cancel'
					}).then(y => {
						this.batch_match()
					}).catch(n=>{console.log(n)}).finally(f=>{});
				}

			}).catch(n=>{console.log(n)}).finally(f=>{});
		},

		export_alignments() {
			if (!this.export_enabled) {
				this.$alert('You must have at least one match specified in order to export aligned database rows.')
				return
			}

			let uri_start = 'https://casenetwork.imsglobal.org/uri/'

			let separator = ','
			let filename = this.project.project_name + '.csv'
			if (this.project.db_delimiter == 'tab') {
				separator = '\t'
				filename = this.project.project_name + '.tsv'
			}

			// construct rows with sids and case URIs
			let lines = 'STANDARD_ID' + separator + 'CASE_URI' + '\n'
			let matches_exported = 0
			for (let dbrow of this.dbrows) {
				// we only export matched rows
				if (dbrow.status == 'matched' && !empty(dbrow.selected_case_item)) {
					lines += dbrow.sid + separator + uri_start + dbrow.selected_case_item.identifier + '\n'
					++matches_exported
				}
			}

			// https://stackoverflow.com/questions/19721439/download-json-object-as-a-file-from-browser
			var data_str = 'data:text/json;charset=utf-8,' + encodeURI(lines)	// encodeURIComponent
			var download_anchor_node = document.createElement('a')
			download_anchor_node.setAttribute('href', data_str)
			// set filename of downloaded json file
			download_anchor_node.setAttribute('download', filename)
			document.body.appendChild(download_anchor_node) // required for firefox
			download_anchor_node.click()
			download_anchor_node.remove()

			let msg = sr('Exported $1 matched standards to <b>$2</b>. The export file includes two columns:<ul><li><b>STANDARD_ID:</b> Your internal database standard ID</li><li><b>CASE_URI:</b> The CASE Network URI for the corresponding standard in the CASE framework</li></ul><br>You can use this file to update your database with the CASE URIs for each of your internal standard IDs.', matches_exported, filename)
			this.$alert({title:'Export Downloaded', text:msg})
		},

		show_help() {
			let html = $('#k-table-view-help').html()
			this.$alert({title:'Instructions', text:html, dialogMaxWidth:800})
		},

	}
}
</script>

<style lang="scss">

.k-table-top-controls-wrapper {
	display:flex;
}

.k-table-top-controls-wrapper-case-tree-showing {
	margin-right:460px;
}

.k-table-top-controls {
	display:flex;
	border-radius:10px;
	background-color:lighten($blue-light, 15%);
	padding:5px 15px;
	min-width:680px;
	// display:flex;
	// align-items:flex-end;
	margin:20px 20px 10px 20px;
	.v-label {
		color:#000!important;
		font-size:15px;
	}

	.k-key-filters {
		.v-label {
			font-weight:bold;
			// font-size:18px;
			white-space:nowrap;
		}
	}
}

.k-search-box-wrapper {
	margin:20px 0 5px 0;
	display:flex;
}

.k-table {
	table {
	}

	td {
		height:auto!important;
		padding-top:5px!important;
		padding-bottom:5px!important;
		vertical-align:top!important;
	}

	.fa-project-diagram {
		color:#999;
	}

	// make footer fixed at bottom of window
	margin-bottom: 60px;
	.v-data-footer {
		position: fixed;
		bottom: 0;
		left: 0;
		background-color: #ddd;
		width: 100vw;
		.v-input {
			margin-top:5px;
			margin-bottom:5px;
			.v-input__slot:before {
				border: 0;
			}
		}
	}
}

.k-table--tree-showing.k-table {
	width: calc(100vw - 480px);

	.v-data-footer {
		width: calc(100vw - 480px);
	}

	.k-table-db-description {
		max-width:calc(50vw - 390px);
	}

	.k-table-case-description {
		max-width:calc(50vw - 380px);
	}
}

.k-table-db-description {
	max-width:calc(50vw - 150px);
	white-space:nowrap;
	overflow:hidden;
	text-overflow:ellipsis;
	cursor:pointer;
}

.k-table-simscore {
	display:inline-block;
	white-space:nowrap;
	vertical-align:top;
	margin-right:15px;
}

.k-table-simscore-span {
	display:inline-block;
	width:32px;
	text-align:right;
}

.k-table-case-description {
	display:inline-block;
	width:calc(50vw - 140px);
	white-space:nowrap;
	overflow:hidden;
	text-overflow:ellipsis;
	vertical-align:top;
	cursor:pointer;
	position:relative;
	padding-right:10px;
	height:22px;

	.k-table-case-description--tree-btn {
		position:absolute;
		right:0px;
		top:3px;
		padding:1px 3px;
		background-color:#fff;
		border-radius:3px;
		margin-top:-1px;
		// opacity:0.95;
	}
}

.k-table-case-description:hover {
	// text-decoration:underline;
}

.k-table__sid-td {
	border-left:5px solid transparent;
	padding-left:5px!important;
	overflow: hidden;
	max-width: 90px;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.k-table__db-desc-td {
	// width:calc(50% - 120px)
}

.k-table__case-items-td {
	border-right:5px solid transparent;
	padding-right:5px!important;
}
.k-table-row--show-all {
	.k-table-db-description, .k-table-case-description {
		white-space:normal;
		height:auto;
	}

	td {
		border-top:5px solid $purple;	// same color as dropdown
		border-bottom:5px solid $purple!important;
	}

	.k-table__sid-td {
		border-left:5px solid $purple!important;
	}

	.k-table__case-items-td {
		border-right:5px solid $purple!important;
	}

	.k-table-row--show-more-link {
		color:$purple!important;
		font-size:1.1em;
	}
}

.k-table-row--batch-matchable {
	background-color:#FFF59D;
}
.k-table-row--batch-matchable:hover {
	background-color:#FFEE58!important;
}

.k-table-row--close-match {
	background-color:#D7CCC8;	// brown
}
.k-table-row--close-match:hover {
	background-color:#BCAAA4!important;
}

.k-table-row--matched {
	background-color:lighten($green-light, 20%);
}
.k-table-row--matched:hover {
	background-color:$green-light!important;
}

.k-table-row--parked {
	background-color:lighten($orange-light, 15%);
}
.k-table-row--parked:hover {
	background-color:$orange-light!important;
}

.k-table-row--nomatch {
	background-color:lighten($red-light, 15%);
}
.k-table-row--nomatch:hover {
	background-color:$red-light!important;
}

.k-table__case-item {
	white-space:nowrap;
}

.k-table__case-item.k-last-case-item-clicked {
	color:$orange-dark;
	font-weight:bold;
}

.k-table__other-case-item {
	border-top:1px solid #ccc;
	padding-top:4px;
	margin-top:4px;
}

.k-table__case-item--copy-of {
	font-size:.85em;
	color:$red;
	font-weight:bold;
}

.k-table__dbrow--non-alignable {
	font-size:.85em;
	color:$red;
	font-weight:bold;
}

.k-case-tree-wrapper {
	position:fixed;
	right:10px;
	bottom:10px;
	width:460px;
	height:calc(100vh - 100px);
	background-color:lighten($orange-light, 20%);
	border:5px solid $orange;
	border-radius:10px;
	font-size:14px;

	.k-case-tree-title {
		height:40px;
		font-weight:bold;
		padding-top:5px;
		padding-left:15px;
		font-size:18px;
		color:$orange;
		cursor:move;

		.fa-grip-vertical {
			color:$orange;
			font-size:1.1em;
			margin-top:-4px;
			margin-right:5px;
		}
	}

	.k-case-tree-inner-wrapper {
		height:calc(100% - 40px);
		padding-left:10px;
		overflow:auto;
	}

	.v-treeview-node__root {
		min-height:30px;
	}

	.v-treeview-node--leaf > .v-treeview-node__root {
		padding-left:16px;
	}

	.k-case-tree-close-btn {
		position:absolute;
		right:-5px;
		top:5px;
	}

	.k-case-tree_case-item--active .v-treeview-node__label {
		color:$orange-dark!important;
		// font-weight:bold;
		overflow: visible!important;
		white-space: normal!important;
	}

	.k-case-tree_case_item {
		.k-case-tree__asign_match {
			position: absolute;
			height: 30px;
			width:30px;
			right: 30px;
			top: 0px;
			padding: 5px 2px 5px 5px;
			background-color:#f9efe5;
			.fa-check-circle {
				font-size:1em;
			}
		}
		.k-case-tree__case_item_opener {
			position: absolute;
			height: 30px;
			width:30px;
			right: 0px;
			top: 0px;
			padding: 5px 5px 5px 2px;
			background-color:#f9efe5;
			.fa-external-link-alt {
				font-size:1em;
			}
		}
	}
}

.k-saved-indicator {
	font-size:0.85em;
	position:fixed;
	z-index:2;
	left: 12px;
	bottom: 12px;
	color:$green;
	font-weight:bold;
	.v-icon { color:$green!important; }
}

</style>
